module.exports = __webpack_public_path__ + "static/media/EnergySmartSlide04.64610189.jpg";